import {useEffect, useRef, useState, useContext} from "react";
import useCanvas from "./useCanvas";
import {Color, Solver} from "../helper";
import {createElementImage, initDevice, reportEvent} from "../../../../../utils";
import {EVENT_TRACER, keyswordsBack, keyswordsFront} from "../../../../../constants";
import {Stream} from "../../helpers/Stream";
import {documentValidator} from "../../../../../services/documentValidator";
import {getConstraints} from "../../helpers";
import { cropImageFromGuide, base64ToBlob, createImageFromBase64, createCanvas, drawImageOnCanvas } from "../../utils";
import {ConfigContext} from "../../../../../context/ConfigContext";

let imgCropped = 'no image'
let worker
let CONFIG
let TIME_TO_CAPTURE_MANUAL = 20
let TIME_TO_CHANGE_MESSAGE_ERROR = 2000
let COLOR_SUCCESS = "#15f51e"

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

export function isMovil() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
let timer
export default function useCamera({containerRef, guideAdo, textPreview, closeIcon, takePhoto, videoRef, canvasRef}) {

    const { value: configValue, loading: configLoading } = useContext(ConfigContext);
    const {getFaces} = useCanvas(showStep)
    const [loading, setLoading] = useState(true)
    const [cameraIsReady, setCameraIsReady] = useState(false);
    const [isImageValidate, setImageValidate] = useState(false)
    const [typeCapture, setTypeCapture] = useState('')
    const [ocr, setOcr] = useState('')
    const [isCard, setIsCard] = useState('')
    const videoInitRef = useRef(null);
    const finished = useRef(null);
    const initProcess = useRef(null);
    const canvasPreviewRef = useRef(null);
    const canvasCroppedImageRef = useRef(null);
    const firstCapture = useRef(true);
    const timerRef = useRef(0);
    const markRef = useRef(null);
    const manualPhotoTaken = useRef(false);
    const [capturedImageBack, setCapturedImageBack] = useState(null);
    const [step, setStep] = useState('');
    const [indicatorRotate, setIndicatorRotate] = useState(true);
    const [stepHistory, setStepHistory] = useState([]);
    const [seconds, setSeconds] = useState(0);
    const captured = useRef(false);

    // GET URL PARAMS
    const isFront = params.isFront || 'true'
    const debug = params.debug || 'false'
    const projectName = params.projectName || 'default'
    const urlServiceLiveness = params.urlServiceLiveness || 'https://vsts-liveness-bknd-dev.ado-tech.com'
    const platform = params.platform || 'web'
    const documentType = params.documentType
    const processId = params.processId
    const urlTracer = params.urlTracer
    const urlService = params.urlService || 'https://api.ado-tech.com';

    function rotateContext(context, angle, width) {
        context.translate(0, width);
        context.rotate(angle);
    }
    function createBase64() {
        const video = videoRef.current;
        if (!video) {
            throw new Error('Video is not available');
        }
        const { videoWidth: width, videoHeight: height } = video;
    
        const originalCanvas = createCanvas(width, height);
        drawImageOnCanvas(originalCanvas, video);   
    
        // const rotatedCanvas = createCanvas(height, width);
        // const rotatedContext = drawImageOnCanvas(rotatedCanvas, originalCanvas);
        // rotateContext(rotatedContext, -Math.PI / 2, width);
    
        return originalCanvas.toDataURL('image/jpeg');
    }
    
    async function callbackAutoCapturing(result) {
        if (captured.current) return
        updateBorder(configValue.styles.successColor)
        captured.current = true;
        const streamRef = Stream.getInstance()
        streamRef.dropStream()
        const image = await createImageFromBase64(result.image);
        const imageResized = cropImageFromGuide(videoRef.current, guideAdo.current)
        setTimeout(() => {
            responseToHost(1, image, imageResized, result.documentName)
        }, 1000)
    }
    async function onReportEvent(eventType, message = '') {
        if (!urlTracer) return
        try {
            const response = await reportEvent(urlTracer, processId, eventType, message)
            console.log('response onReportEvent', response);
        } catch (e) {
            console.log('error report event', e.message)
        }
    }
    function initTimer() {
        timer = setInterval(() => {
            timerRef.current = timerRef.current + 1
            setSeconds(prevState => prevState + 1)
        }, 1000);
    }
    async function startCameraDesktop(currentTypeCapture) {
        const constraintsDesktop = {
            video: true
        };
        videoRef.current.srcObject = await navigator.mediaDevices.getUserMedia(constraintsDesktop);

        await captureImage(currentTypeCapture)
    }

    function textPreviewMessage () {
        if (typeCapture === '1') {
            return CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto'
        } else {
            return CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto'
        }
    }
    function changeGuideToDanger() {
        containerRef.current.classList.add('danger')

        textPreview.current.innerText = 'Verifica que tu cédula se pueda leer claramente.'
        
        setTimeout(() => {
            textPreview.current.innerText = textPreviewMessage()
            containerRef.current.classList.remove('danger')

        }, TIME_TO_CHANGE_MESSAGE_ERROR)
    }
    
    async function takeManualPhoto() {
    await onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureInitCaptureManual, 'Ha entrado en captura manual');
    if (manualPhotoTaken.current) return;
    manualPhotoTaken.current = true;

    try {
        setLoading(true);
        const imageResized = cropImageFromGuide(videoRef.current, guideAdo.current)
        containerRef.current.classList.replace('display-elements', 'hide-elements');
        takePhoto.current.classList.add('hide');
        const imageRotated = createBase64();
        const imageResizedBlob = await base64ToBlob(imageRotated)
        const response = await documentValidator(imageResizedBlob, urlService, isFront, documentType);
        setLoading(false);
        
        if (response.data.quality) {
            await onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureTakePhoToManual, 'El usuario a tomado una foto manual');
            responseToHost(isFront === 'true' ? 1 : 2, imageRotated, imageResized);
        } else {
            changeGuideToDanger();
            containerRef.current.classList.replace('hide-elements', 'display-elements');
            takePhoto.current.classList.remove('hide');
            manualPhotoTaken.current = false;
        }
    } catch (e) {
        console.error('takeManualPhoto error', e);
        responseToHostError(isFront === 'true' ? 'Frontal' : 'Trasera', e.message);
    }
}
async function getVideoInputs() {
    const devices = await navigator.mediaDevices.enumerateDevices();
    let videoInputs = [];

    videoInputs = devices.filter(device => device.kind === 'videoinput');

    // const rearCameraLabels = [
    //     'rear',         // Common in Windows devices
    //     'Rear Camera',   // Surface/Windows rear camera
    //     'back',         // General label for back camera
    //     'facing back',   // Android label
    //     'Cámara trasera', // Spanish label for rear camera (iOS)
    //     'Back Triple Camera', // iOS triple camera label
    //     'Back Camera',   // General back camera
    // ];

    let rearCameras;

    rearCameras = videoInputs.filter(device => 
        ["rear", "Rear Camera"].some(label => device.label.toLowerCase().includes(label.toLowerCase()))
    );

    if (rearCameras.length > 0) return rearCameras


    rearCameras = videoInputs.filter(device => 
        device.label.includes("facing back") && device.label.includes("0")
    );

    if (rearCameras.length > 0) return rearCameras

    rearCameras = videoInputs.filter(device => 
        ["back", "facing back", "Back Camera"].some(label => device.label.toLowerCase().includes(label.toLowerCase()))
    );

    if (rearCameras.length > 0) return rearCameras

    rearCameras = videoInputs.filter(device => 
        ["Back Triple Camera", "Cámara trasera"].some(label => device.label.toLowerCase().includes(label.toLowerCase()))
    );

    if (rearCameras.length > 0) return rearCameras

    // Fallback to front camera if no rear camera found
    if (rearCameras.length <= 0) {
        rearCameras = videoInputs.filter(device => 
            device.label.toLowerCase().includes('front') || 
            device.label.toLowerCase().includes('webcam') ||
            device.label.toLowerCase().includes('integrated')
        );
    }

    return rearCameras

}

async function startCamera(cameraType) {
    // se obtiene la configuración de la cámara
    const constrains = getConstraints(initDevice().isMac, 'environment');
    try {
        let selectedCameraId;
        const stream = await navigator.mediaDevices.getUserMedia(constrains)
        let currentStream = stream
        let constraintsMovil = constrains
        if (initDevice().isAndroid || initDevice().isIos) {
            const videoInputs = await getVideoInputs();
            if (videoInputs.length > 0) {
                selectedCameraId = videoInputs[0]?.deviceId
                constraintsMovil = {
                    video: {
                        deviceId: { exact: selectedCameraId },
                        width: { ideal: 1920 },
                        height: { ideal: 1080 },
                        advanced: [
                            { focusMode: "continuous" }
                        ]
                    }
                }
                if (!selectedCameraId) delete constraintsMovil.video.deviceId
                stream.getVideoTracks()[0].stop()
                currentStream = await navigator.mediaDevices.getUserMedia(constraintsMovil)
            }
        }

        setTimeout(async () => {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            const canvasContext = canvas.getContext('2d');
            canvasContext.imageSmoothingEnabled = true

            onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraOpen, 'Camara del card capture iniciada');
            
            const streamRef = Stream.getInstance(initDevice(), '/models', true, urlService)
            streamRef.updateHtmlElements(videoRef.current, canvasRef.current)
            streamRef.setFaceDetection(true);
            streamRef.setCallbackAutoCapturing(callbackAutoCapturing)
            streamRef.setCallbackFaceDetectionErrors(() => {
                if (!onManualCapture.current) {
                    containerRef.current.classList.add('danger')
                } else {
                    containerRef.current.classList.remove('danger')
                    containerRef.current.classList.remove('success')
                }
            })
            await setConfigValues()
            initTimer()
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            containerRef.current.classList.replace('hide-elements', 'display-elements');
            await streamRef.startDetection()
            setLoading(false)
            video.muted = true;
            video.srcObject = currentStream;
        }, 3000)
        
    } catch (error) {
        console.error('Error starting camera:', error)
        await onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraError, error.message);
        setLoading(false)
        responseToHostError(cameraType, error.message)
    }
}

    function stopCamera() {
        try {
            const stream = videoRef.current.srcObject;
            const streamInit = videoInitRef.current.srcObject;
            if (stream) {
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
            }
            if (streamInit) {
                const tracks = streamInit.getTracks();
                tracks.forEach(track => track.stop());
            }
            videoRef.current.srcObject = null;
            videoInitRef.current.srcObject = null;
        } catch (e) {
            console.log('error stopCamera', e)
        }
    }


    function showStep(message, show= true) {
        if (show) {
            setStepHistory(prevState => [...prevState, message])
            setStep(message)
        }
    }

    async function captureImage(type) {
        showStep(`Capture image ${type}`)
        const video = videoRef.current;
        const canvas = canvasRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        // canvas.width = 20;
        // canvas.height = 20;

        drawImageOnCanvas(canvas, video)
        // const context = canvas.getContext('2d');
        // context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const capturedDataUrl = canvas.toDataURL('image/jpeg');
        showStep('Image to data url')
        const imgElement = await createElementImage(capturedDataUrl);

        const imagebase64 = capturedDataUrl

        if (type === 1) {

            let imageToResponse = imagebase64
            setTimeout(async () => {
                const hasFaces = await getFaces(imgElement)
                if (!hasFaces.haarFace) {
                    setImageValidate(false)
                    imgElement.remove()
                    showStep('captureImage 1', true)
                    await captureImage(1)
                    return
                }
                setImageValidate(true)
                setCameraIsReady(false)
                const isOcr = await validateOCR(imagebase64, keyswordsFront);
                if (!isOcr) {
                    // setOcr('No')
                    await captureImage(1)
                    return
                }
                setOcr('Si')
                console.log('captureImage')
                responseToHost(type, imageToResponse)
            }, 200)
        } else {
            setTimeout(async () => {
                const isOcr = await validateOCR(imagebase64, keyswordsBack);
                if (!isOcr) {
                    setOcr('No')
                    await captureImage(2)
                    return
                }
                setOcr('Si')
                setCameraIsReady(false)
                responseToHost(type, imagebase64)
            }, 200)
        }
    }

    function checkKeywords(text, keywords) {
        const words = keywords.toLowerCase().split(' ');
        const lowerText = text.replace(/[^a-zA-Z0-9-\s]/g, "").toLowerCase();
        for (const word of words) {
            if (lowerText.includes(word)) {
                return true;
            }
        }
        return false;
    }

    function responseToHost(type, image, imageCropped, additionalData) {
        clearInterval(timer)
        showStep("responseToHost")
        finished.current = true

        if (videoRef.current) {
            videoRef.current.style.display = 'none'
        }
        if (guideAdo.current) {
            guideAdo.current.style.display = 'none'
        }
        if (textPreview.current) {
            textPreview.current.style.display = 'none'
        }

        stopCamera()
        console.log('returned:')
        console.log({
            type: 'success',
            step: type === 1 ? 'frontCapture' : 'backCapture',
            data: image,
            cropped: imageCropped,
            documentType: additionalData,
        })
        const imageref = document.getElementById("imgResult");
        imageref.src = imageCropped
        imageref.style.display = 'block'
        const videoContainerRef = document.getElementById("container-ado-camera");
        if (videoContainerRef) {
            videoContainerRef.style.display = 'none'
        }
        closeIcon.current.style.display = 'none'

        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost, 'El servicio emitio al host').catch()
        const payload = {
            type: 'success',
            step: type === 1 ? 'frontCapture' : 'backCapture',
            data: imageCropped,
            cropped: imageCropped,
            documentType: additionalData,
        }

        // if (platform === 'ios') {
        //     window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify(payload));
        //     return;
        // }

        // if (platform === 'android') {
        //     window.ResponseAdo.handleEvent(JSON.stringify(payload));
        //     return
        // }

        // if (platform === 'react-native') {
        //     window.ReactNativeWebView.postMessage(JSON.stringify(payload))
        //     return
        // }
        // window.parent.postMessage(
        //     JSON.stringify(payload),
        //     '*'
        // );
    }
    function responseToHostError(type, message) {
        finished.current = true

        if (videoRef.current) {
            videoRef.current.style.display = 'none'
        }
        if (guideAdo.current) {
            guideAdo.current.style.display = 'none'
        }
        if (textPreview.current) {
            textPreview.current.style.display = 'none'
        }
        stopCamera()
        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost, message).catch()
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }));
            return;
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }));
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }))
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }),
            '*'
        );
    }
    async function validateOCR(image, keywords, type, imgElement) {
        return new Promise(async (resolve, reject) => {
            showStep('Init validate OCR')
            try {
                const { data: { text } } = await worker.recognize(image);
                setOcr(text)

                const includesKeyword = checkKeywords(text, keywords);
                resolve(includesKeyword)

            } catch (error) {
                // showStep(`Error -> ${error.message}`)
                console.log('error isCard', error)
                reject(error)

            }
        })
    }

    function goBack() {
        setOcr('clicked back')
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }));
            return;
        }

        if (platform === 'android') {
            window.FinishClose.goBack();
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }))
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }),
            '*'
        );
    }

    function generateFilterValue(hexColor) {
        // Verificar si el valor hexadecimal es válido
        if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hexColor)) {
            throw new Error('Valor hexadecimal no válido.');
        }

        // Remover el signo '#' si está presente
        hexColor = hexColor.replace('#', '');

        // Separar el valor en componentes (rojo, verde, azul)
        let r, g, b;

        if (hexColor.length === 3) {
            r = parseInt(hexColor[0] + hexColor[0], 16);
            g = parseInt(hexColor[1] + hexColor[1], 16);
            b = parseInt(hexColor[2] + hexColor[2], 16);
        } else {
            r = parseInt(hexColor.slice(0, 2), 16);
            g = parseInt(hexColor.slice(2, 4), 16);
            b = parseInt(hexColor.slice(4, 6), 16);
        }

        // Calcular los valores de filtro
        const invertValue = `${100 - (r / 255 * 100)}%`;
        const sepiaValue = `${(g / 255 * 100)}%`;
        const saturateValue = `${r / 255 * 6000}%`;
        const hueRotateValue = `${(g / 255 * 360)}deg`;
        const brightnessValue = `${(b / 255 * 200)}%`;
        const contrastValue = `${(g / 255 * 200)}%`;

        // Construir la cadena de filtro
        const filterValue = `invert(${invertValue}) sepia(${sepiaValue}) saturate(${saturateValue}) hue-rotate(${hueRotateValue}) brightness(${brightnessValue}) contrast(${contrastValue})`;

        return filterValue;
    }
    function hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (m, r, g, b) => {
            return r + r + g + g + b + b;
        });

        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? [
                parseInt(result[1], 16),
                parseInt(result[2], 16),
                parseInt(result[3], 16),
            ]
            : null;
    }
    function generateFilterValue2(hexColor) {
        const rgb = hexToRgb(hexColor)
        const color = new Color(rgb[0], rgb[1], rgb[2]);
        const solver = new Solver(color);
        return solver.solve()
    }

    // Update the text preview based on the configCardCapture
    function updateTextPreview(messages, typeCapture) {
        console.log(messages, typeCapture)
        if (messages && textPreview.current) {
            const { messageFront, messageBack, fontFamily, fontSize } = messages;
            const text = typeCapture === '1' ? messageFront : messageBack;
            textPreview.current.innerText = text;
            // textPreview.current.style.fontFamily = fontFamily;
        }
    }
    
    // Update the close icon based on the configCardCapture
    function updateCloseIcon(closeIcon) {
        
        if (closeIcon && closeIcon.current) {
            const { url, size, color } = closeIcon;
            const iconSize = size || '30px';
            
            if (url && isMovil()) {
                closeIcon.current.innerHTML = `<img alt="img-back" style="width: 100%" src="${url}"/>`;
                closeIcon.current.style.cssText = `height: ${iconSize}; width: ${iconSize};`;
            } else {
                closeIcon.current.innerText = "X";
                closeIcon.current.style.cssText = `font-size: ${iconSize}; color: ${color || 'white'};`;
            }
        }
    }
    
    // Update the border based on the colors
    function updateBorder(color) {
        if (isMovil() && guideAdo.current) {
            guideAdo.current.style.border = `3px solid ${color}`;
        } else {
            videoRef.current.style.border = `5px solid ${color}`;
        }
    }
    async function setConfigValues() {
        console.log(configValue)
        if (Object.keys(configValue).length > 0) {
            TIME_TO_CAPTURE_MANUAL = configValue.timeout;
            CONFIG = configValue;
            console.log(configValue)
            updateTextPreview(configValue.messages, isFront === "true" ? '1' : '2');
            updateCloseIcon(configValue.closeIcon);
        }
    }

    useEffect(() => {
        if (projectName && !isMovil() && !configLoading) {
            setConfigValues()
        }
    }, [projectName, configLoading])

    useEffect(() => {
        if (!initProcess.current) {
            initProcess.current = true
            if (isFront === 'true' || isFront === 'true/') {
                setTypeCapture('1')
                isMovil() ? startCamera(1).catch() : startCameraDesktop(1).catch()
            } else {
                setTypeCapture('2')
                isMovil() ? startCamera(2).catch() : startCameraDesktop(2).catch()
            }
        }
    }, [])

    // Si el tiempo de captura automática se cumple y no se ha capturado manualmente, se muestra el botón de captura manual
    const onManualCapture = useRef(false);
    if (timerRef.current === TIME_TO_CAPTURE_MANUAL && isMovil() && !onManualCapture.current) {
        const streamRef = Stream.getInstance()
        streamRef.dropStream()
        containerRef.current.classList.remove('danger')
        takePhoto.current.classList.remove('hide')
        onManualCapture.current = true

        if (textPreview.current) {
            textPreview.current.innerText = textPreviewMessage()
        }
        
        clearInterval(timer)
    }

    return {
        capturedImageBack,
        cameraIsReady,
        isCard,
        canvasPreviewRef,
        indicatorRotate,
        isImageValidate,
        canvasCroppedImageRef,
        ocr,
        debug,
        step,
        stepHistory,
        typeCapture,
        markRef,
        loading,
        projectName,
        isMovil,
        goBack,
        takeManualPhoto,
    }
}
